import { render, staticRenderFns } from "./scanFail.vue?vue&type=template&id=80cfda94&scoped=true&"
import script from "./scanFail.vue?vue&type=script&lang=js&"
export * from "./scanFail.vue?vue&type=script&lang=js&"
import style0 from "./scanFail.vue?vue&type=style&index=0&id=80cfda94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cfda94",
  null
  
)

export default component.exports